/*
 * Package: WebVideo.UIUtils
 * Version: $Id$
 * Copyright (c) 2012 Sergey Leonov
 */

function UIUtils() {}

UIUtils.openNewWindow = function (url, target, specs) {
  specs = StringUtils.NVL(specs, '');
  var newWin = window.open(url, target, specs),
      hasPopupBlocker = !newWin || typeof(newWin) == 'undefined' || typeof(newWin.innerHeight) == 'undefined' || newWin.innerHeight < 1;

  if (hasPopupBlocker && typeof(jQuery.fn.activebar) != 'undefined') {
    var text = I18n.t('Pop-Up Window can not be opened automatically in this browser. {1}Click here{2} to open new window.', [
        '<a target="_blank" href="' + url + '" onclick="jQuery.fn.activebar.hide();">',
        '</a>'
    ]);
    jQuery('<div></div>').html(text).activebar({
        'background': 'InfoBackground',
        'highlight': 'InfoBackground',
        'icon': '/libs/vendor/jquery/activebar/images/information.gif',
        'button': '/libs/vendor/jquery/activebar/images/closebtn.gif'
    });
  }
};

UIUtils.redirect = function (url, req_data, method, target) {
  url = StringUtils.NVL(url, null);
  if (url == null) return;
  req_data = StringUtils.NVL(req_data, null);
  method = StringUtils.NVL(method, 'get');
  method = (method.toLocaleLowerCase() == 'post') ? 'post' : 'get';
  target = StringUtils.NVL(target, "_self");

  var _form_id = 'frm_' + (new Date()).getTime();
  var _html = '<div style="display:none;"><form name="' + _form_id + '" id="' + _form_id + '" action="' + url + '" method="' + method + '" target="' + target + '" accept-charset="UTF-8">';
  if (req_data != null) {
    for(var k in req_data) {
      _html += '<input type="hidden" name="' + k + '" value="' + req_data[k] + '" />';
    }
  }
  _html += '</form></div>';

  jQuery('body').append(_html);
  jQuery("#" + _form_id).submit();
};

UIUtils.showMaximized = function(container, width, height, maxWidth, maxHeight) {
  var url = container.href;
  if ('' == url || '#' == url) {
    return false;
  }
  var calcMaxProportions = function(width, height, maxWidth, maxHeight) {
    var k = 1;
    if(width > maxWidth || height > maxHeight) {
      if(width / height > maxWidth / maxHeight) {
        k = maxWidth / width;
        width = width * k;
        height = height * k;
      } else {
        k = maxHeight / height;
        width = width * k;
        height = height * k;
      }
    }
    return {width: width, height: height};
  };

  var newWindow = (typeof(jQuery.fn.nyroModal) == 'undefined' || document.compatMode == 'BackCompat'),
      base_url = jQuery('base').attr('href'),
      isImage = url.match(/.*\.(jpe?g|gif|png|bmp|tiff)(\?.*)?\s*$/i) != null,
      html = '';

  if(!url.match(/^https?:\/\//i)) url = base_url + url;

  //image
  if(isImage) {
    html = '<img src="' + url + '" width="' + width + '" height="' + height + '" alt="" />';
  }
  //swf
  else if(url.match(/.*\.(swf)(\?.*)?\s*$/i)) {
    html = ''
      + '<object classid="clsid:D27CDB6E-AE6D-11cf-96B8-444553540000" codebase="http://download.macromedia.com/pub/shockwave/cabs/flash/swflash.cab#version=7,0,19,0"'
      + ' width="' + width + '" height="' + height + '">'
      + '<param name="movie" value="' + url + '" />'
      + '<embed src="' + url + '" width="' + width + '" height="' + height + '"'
      + ' pluginspage="http://www.macromedia.com/go/getflashplayer" type="application/x-shockwave-flash" />'
      + '</object>';
  }
  //mov
  // else if(url.match(/.*\.(mov)(\?.*)?\s*$/i)) {
  //   height += 16;
  //   html = ''
  //     + '<object classid="clsid:02BF25D5-8C17-4B23-BC80-D3488ABDDC6B" codebase="http://www.apple.com/qtactivex/qtplugin.cab"'
  //     + ' width="' + width + '" height="' + height + '">'
  //     + '<param name="src" value="' + url + '" />'
  //     + '<param name="autoplay" value="true" />'
  //     + '<param name="controller" value="true" />'
  //     + '<embed src="' + url + '" width="' + width + '" height="' + height + '"'
  //     + ' autoplay="true" controller="true"'
  //     + ' pluginspage="http://www.apple.com/quicktime/download/" type="video/quicktime" />'
  //     + '</object>';
  // }
  //flv, mp4
  else if(url.match(/.*\.(flv|f4v|mp4|m4v|mov)(\?.*)?\s*$/i)) {
    var thumbnail = $(container).find('img').attr('src');
    var extention = url.substr(url.lastIndexOf('.') + 1).toLocaleLowerCase();
    if (extention.indexOf("?") != -1) {
      extention = extention.substr(0, extention.indexOf("?"));
    }

    var mimeTypes = {
        "flv" : "video/x-flv",
        "f4v" : "video/x-f4v",
        "mp4" : "video/mp4",
        "m4v" : "video/mp4",
        // NOTE: Mime type for mov should be video/mp4 (not video/quicktime).
        // Because [video.js script](https://github.com/videojs/video.js) don't play video/quicktime in chrome browser.
        "mov" : "video/mp4"
    };
    if (!maxWidth) maxWidth = 640;
    if (!maxHeight) maxHeight = 480;

    if (width > maxWidth) {
      height = Math.ceil(maxWidth / width * height);
      width = maxWidth;
    }
    if (height > maxHeight) {
      height = maxHeight;
      width = Math.ceil(maxHeight / height * width);
    }

    html =
    '<video id="videojs-preview" class="video-js" controls preload="auto" width="' + width + '" height="' + height + '"' +
      'poster="' + thumbnail + '" data-setup="{}">' +
    '  <source src="' + url + '" type="' + mimeTypes[extention] + '">' +
    '  <p class="vjs-no-js">' +
    '    To view this video please enable JavaScript, and consider upgrading to a web browser that' +
    '  </p>' +
    '</video>';

    var videojsInit = function () {
      try {
        const player = videojs("videojs-preview");

        player.ready(function(){
          var videoPlayer = this;
          setTimeout(function () {
            try {
              videoPlayer.play();
            } catch (e) {
              console.error(e);
            }
          }, 300);
        });
        
        player.on('error', function(ev) {
          var error = this.error();
          if (
            error.code == 4
            && (extention == "flv" || extention == "f4v")
            && !swfobject.hasFlashPlayerVersion("9.0.124")
          ) {
            $(".vjs-error-display", ev.taget)
              .addClass("flash-missing")
              .on("click", function() {
                window.location = 'http://www.adobe.com/go/EN_US-H-GET-FLASH';
              })
              .find(".vjs-modal-dialog-content")
              .html(
                I18n.t("Adobe Flash Player either is not installed in your browser or has older version than required.") +
                '<br />' +
                I18n.t("Click here to install it.")
              );
          }
        });
      } catch (e) {
        console.error(e)
        return false;
      }
    };
  }
  //other
  else {
    height += 45;
    html = ''
      + '<object classid="clsid:22d6f312-b0f6-11d0-94ab-0080c74c7e95" codebase="http://activex.microsoft.com/activex/controls/mplayer/en/nsmp2inf.cab#Version=5,1,52,701"'
      + ' standby="Loading player components..." type="application/x-oleobject"'
      + ' width="' + width + '" height="' + height + '">'
      + '<param name="fileName" value="' + url + '" />'
      + '<param name="animationatStart" value="true" />'
      + '<param name="transparentatStart" value="true" />'
      + '<param name="showControls" value="true" />'
      + '<embed src="' + url + '" width="' + width + '" height="' + height + '"'
      + ' showcontrols="true"'
      + ' pluginspage="http://microsoft.com/windows/mediaplayer/en/download/" type="application/x-mplayer2" />'
      + '</object>';
  }

  if(newWindow) {
    var coords = calcMaxProportions(width, height, screen.width, screen.height-60);
    width = coords.width;
    height = coords.height;
    var left = (screen.width-width)/2;
    var top = (screen.height-60-height)/2;
    if(left < 0) left=0;
    if(top < 0) top = 0;
    var openedWindow = window.open('about:blank', '_blank', 'height='+height+',width='+width+',left='+left+',top='+top+',location=no,menubar=no,resizable=yes,status=no,toolbar=no,scrollbars=no');
    openedWindow.document.write(
      '<!DOCTYPE HTML>'
      + '<html><head>'
      + '<meta http-equiv="Content-Type" content="text/html; charset=utf-8" />'
      + '<base href="' + base_url + '" />'
      + '<style type="text/css">body,td {padding:0; margin:0; border:0; text-align:center; overflow:hidden;} img{border:0; vertical-align:middle;}</style>'
      + '</head><body>'
      + '<div style="width:' + width + 'px; height:' + height + 'px; padding:0; margin:0; border:0; overflow:hidden;">'
      + html
      + '</div>'
      + '</body></html>'
    );
    return false;
  } else {

    if(isImage) {
      jQuery(container).attr({'target': '_self'}).nyroModal().nmCall();
    } else {
      var coordsVideo = calcMaxProportions(width, height, Math.min(screen.width, 640), Math.min(480, screen.height-60));
      width = coordsVideo.width;
      height = coordsVideo.height;
      jQuery.nmData(''
        + '<div id="wp-ca933e3c-d18b-11e1-bf9e-001bfc70c0c0" style="width:' + width + 'px; height:' + height + 'px; padding:0; margin:0; border:0; overflow:hidden;">'
        + html
        + '</div>', {
        'sizes': {
          'w': width,
          'h': height
        },
        callbacks: {
          beforeClose: function() {
            if (videojsInit !== undefined) {
              videojs('videojs-preview').dispose();
            }
          }
        }
      });
      if (videojsInit !== undefined) videojsInit();
    }
    return false;
  }


};

/*page title blink*/

UIUtils.ptb_opts = {
  'timer_id': null,
  'focus': false,
  'title_original': document.title,
  'title_blink': ''
};

UIUtils.startPageTitleBlink = function (title_blink) {
  if (UIUtils.ptb_opts['timer_id'] == null && !UIUtils.ptb_opts['focus']) {
    UIUtils.ptb_opts['title_original'] = document.title;
    UIUtils.ptb_opts['timer_id'] = setInterval(function() {
      document.title = (document.title == UIUtils.ptb_opts['title_original']) ? title_blink : UIUtils.ptb_opts['title_original'];
    }, 1500);
  }
};

UIUtils.stopPageTitleBlink = function () {
  if (UIUtils.ptb_opts['timer_id'] != null) clearInterval(UIUtils.ptb_opts['timer_id']);
  UIUtils.ptb_opts['timer_id'] = null;
  document.title = UIUtils.ptb_opts['title_original'];
};

jQuery(document).ready(function() {

  jQuery('body').mouseenter(function() {
    UIUtils.ptb_opts['focus'] = true;
    UIUtils.stopPageTitleBlink();
  });

  jQuery('body').mouseleave(function() {
    UIUtils.ptb_opts['focus'] = false;
  });
  
});

UIUtils.addDefValueToInput = function (selector, def_text) {
  jQuery(selector).focusin(function() {
    var el = jQuery(this);
    var val = el.val();
    if (val == def_text) el.val('');
  }).focusout(function() {
    var el = jQuery(this);
    var val = el.val();
    if (val.length == 0) el.val(def_text);
  }).each(function() {
    var el = jQuery(this);
    var val = el.val();
    if (val.length == 0) el.val(def_text);
  });

};

var openNewWindow = UIUtils.openNewWindow,
    redirect = UIUtils.redirect,
    showMaximized = UIUtils.showMaximized,
    addDefValueToInput = UIUtils.addDefValueToInput;